if (typeof BSS_B2B != undefined) {
  document.addEventListener("DOMContentLoaded", function () {
    const addToCartBtn = document.querySelector('button[name="add"][data-add-to-cart]');
  
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", function (event) {
        setTimeout(() => {
          const cartItems = document.querySelectorAll(".cart__item");
          if (cartItems.length) {
             console.log(BSS_B2B.shopData.cart.items)
          }
        }, 2000)
      });
    }
  });

}